package ai.wagemix.net.models

/**
 * A file the user picked, read into memory for upload. The factory copies [bytes] so a caller
 * that keeps the original buffer cannot change the file after it was handed over.
 */
interface WMUploadFile {
    val name: String
    val contentType: String
    val bytes: ByteArray

    companion object
}

fun WMUploadFile.Companion.of(name: String, contentType: String, bytes: ByteArray): WMUploadFile {
    return WMUploadFileData(name = name, contentType = contentType, bytes = bytes.copyOf())
}

private class WMUploadFileData(
    override val name: String,
    override val contentType: String,
    override val bytes: ByteArray
): WMUploadFile {
    override fun equals(other: Any?): Boolean {
        return other is WMUploadFileData && other.name == name && other.contentType == contentType && other.bytes.contentEquals(bytes)
    }

    override fun hashCode(): Int = 31 * (31 * name.hashCode() + contentType.hashCode()) + bytes.contentHashCode()

    override fun toString(): String = "WMUploadFile(name=$name, contentType=$contentType, bytes=${bytes.size})"
}
